import Vue from 'vue'
import VueRouter from 'vue-router'

import guards from './guards'
import { HOME_ROUTE } from './utils'

import Login from '@/views/Login.vue'
import Signup from '@/views/Signup.vue'
import Checkout from '@/views/Checkout.vue'
import Redeem from '@/views/Redeem.vue'
import PartnerShip from '@/views/PartnerShip.vue'
import Account from '@/views/Account.vue'
import PlayHubAccount from '@/views/PlayHubAccount.vue'

const Home = () => import(/* webpackChunkName: "base" */ '@/views/Home.vue')
const PlaylistGroupView = () => import(/* webpackChunkName: "base" */ '@/views/PlaylistGroupView.vue')
const WatchVideo = () => import(/* webpackChunkName: "base" */ '@/views/WatchVideo.vue')

const Demo = () => import(/* webpackChunkName: "demo" */ '@/views/Demo.vue')
const Inactive = () => import(/* webpackChunkName: "inactive" */ '@/views/Inactive.vue')

const authorizedRouteRedirects = { unauthenticated: { name: 'login' }, unauthorized: { name: 'checkout' } }
const unauthorizedRouteRedirects = { authorized: { name: 'browse' }, unauthenticated: { name: 'login' } }
const unauthenticatedRouteRedirects = { authorized: { name: 'browse', path: '/parcerias/:partner' }, unauthorized: { name: 'checkout' } }
const conversionRedirects = { authorized: { name: 'browse' } }

Vue.use(VueRouter)

const routes = [
  {
    path: '/partnership/:partner',
    name: 'partnership',
    component: PartnerShip
  }, {
    path: '/playhub/account',
    name: 'playhub-account',
    component: PlayHubAccount
  }, {
    path: '/parcerias/:partner',
    name: 'parcerias',
    component: PartnerShip
  }, {
    path: '/checkout',
    name: 'checkout',
    component: Checkout,
    meta: { redirects: conversionRedirects, requiresContentTree: false }
  }, {
    path: '/browse',
    name: 'browse',
    component: Home,
    meta: { redirects: authorizedRouteRedirects, requiresContentTree: true }
  }, {
    path: '/login/:type?',
    name: 'login',
    component: Login,
    meta: { redirects: unauthenticatedRouteRedirects, requiresContentTree: false }
  }, {
    path: '/signup/:offer?',
    name: 'signup',
    component: Signup,
    meta: { redirects: unauthenticatedRouteRedirects, requiresContentTree: false }
  }, {
    path: '/redeem/:offer',
    name: 'redeem',
    component: Redeem,
    meta: { redirects: conversionRedirects, requiresContentTree: false }
  }, {
    path: '/demo/:playlistGroup?',
    name: 'demo',
    component: Demo,
    meta: { redirects: conversionRedirects, requiresContentTree: true }
  }, {
    path: '/inactive',
    name: 'inactive',
    component: Inactive,
    meta: { redirects: unauthorizedRouteRedirects, requiresContentTree: false }
  }, {
    path: '/playlist-group/:id',
    name: 'playlist-group-view',
    component: PlaylistGroupView,
    meta: { redirects: authorizedRouteRedirects, requiresContentTree: true }
  }, {
    path: '/playlist-group/:id/watch',
    name: 'autoplay-video',
    component: PlaylistGroupView,
    meta: { redirects: authorizedRouteRedirects, requiresContentTree: true }
  }, {
    path: '/playlist-group/:playlistGroupId/playlist/:playlistId/watch/:id',
    name: 'watch-video',
    component: WatchVideo,
    meta: { redirects: authorizedRouteRedirects, requiresContentTree: true }
  }, {
    path: '/account',
    name: 'account',
    component: Account,
    meta: { redirects: authorizedRouteRedirects, excludedPlatforms: ['PLAYPHONE'], requiresContentTree: false }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: (to, from, saved) => {
    if (from && to && to.name === from.name) {
      return
    }

    return saved || { x: 0, y: 0 }
  }
})

VueRouter.prototype.home = function(replace) {
  if (replace) {
    this.replace(HOME_ROUTE)
  } else {
    this.push(HOME_ROUTE)
  }
}

router.beforeEach(guards)

export default router
